<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_560_1182)">
            <path
                d="M7.99992 14.6666C11.6818 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 4.31802 11.6818 1.33325 7.99992 1.33325C4.31802 1.33325 1.33325 4.31802 1.33325 7.99992C1.33325 11.6818 4.31802 14.6666 7.99992 14.6666Z"
                stroke="#404245" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M6.06006 5.99989C6.21679 5.55434 6.52616 5.17863 6.93336 4.93931C7.34056 4.7 7.81932 4.61252 8.28484 4.69237C8.75036 4.77222 9.1726 5.01424 9.47678 5.37558C9.78095 5.73691 9.94743 6.19424 9.94673 6.66656C9.94673 7.99989 7.94673 8.66656 7.94673 8.66656"
                stroke="#404245" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 11.3333H8.00667" stroke="#404245" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_560_1182">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

</template>